import React from "react";

//Local Libraries
import phrasebookLoad from "../../../i18n"; import { gisRoutes } from "../../../routes/routes";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { notificationActions } from '../../../actions';
import { userStorage } from '../../../helpers/user-storage';

//Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";
import { connect } from "react-redux";
// Constants
const phrasebook = phrasebookLoad()

class AddTicket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      functionality_id: 800,
      notification_title: undefined,
      notification_message: undefined,
      creator_customer_id: userStorage.getUser() && userStorage.getUser().customer_id ? userStorage.getUser().customer_id : undefined,
      creator_account_id: userStorage.getUser() && userStorage.getUser().id ? userStorage.getUser().id : undefined,
      receiver_account_id: undefined,
      notification_status: "requested",
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      notification_title: this.state.notification_title,
      notification_message: this.state.notification_message,
      functionality_id: this.state.functionality_id,
      creator_customer_id: this.state.creator_customer_id,
      creator_account_id: this.state.creator_account_id,
      receiver_account_id: this.state.receiver_account_id,
      notification_status: this.state.notification_status
    }
    // if (token.loggedAccountType())
    this.props.dispatch(notificationActions.add(newValues));
  }

  FormProfile = () => {
    const titleOptions = [{ value: 'Order Issue', label: 'Order Issue' }, { value: 'Portal Issue', label: 'Portal Issue' }, { value: 'Other', label: 'Other' }];
    const inputs = [
      { label: phrasebook.common.title, type: "select", id: "notification_title", name: "notification_title", options: titleOptions, selected: this.state.notification_title, empty_option: true },
      {
        label: phrasebook.support.ticket_details, type: "textarea", placeholder: "Describe your request",
        id: "notification_message", name: "notification_message", value: this.state.notification_message, details: phrasebook.common.max_250_words
      }
    ]

    const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.dashboard[this.account_type_logged]} />, <SubmitButton title={phrasebook.common.add} />]
    return (
      <Form
        handleSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={phrasebook.support.report_issue}
        inputs={inputs}
        buttons={buttons}
      />)
  }
  render() {
    return (
      <>
        <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.support.add_ticket} />
        {this.FormProfile()}
      </>);
  }
}
function mapStateToProps(state) {
  const { authentication, account, customer } = state;
  const { authUser } = authentication;
  return {
    authUser,
    customers: customer.customers
  };
}

const addTicket = connect(mapStateToProps)(AddTicket);

export default (addTicket);
